import { memo } from 'react';

import SortMenu from '@/apps/mwd-v2/components/SortMenu/SortMenu';

import useWeekday from '../../state/selectors/useWeekday';
import ClockButton from '../Timescale/ClockButton';

import ZoomControls from './Zoom/ZoomControls';

import styles from './Controlbar.module.css';

const Zoom = memo(ZoomControls);
const Clock = memo(ClockButton);

const Controlbar = () => {
  const { weekDay } = useWeekday();

  return (
    <div style={{ position: 'relative', height: '40px', overflowY: 'visible' }}>
      <div className={styles.mwdControlbarStyle} style={{ height: '40px', overflowY: 'visible' }}>
        <div className={styles.mwdControlbarZoomSortParentContainer}>
          <div className={styles.mwdControlbarZoomSortContainer}>
            <Zoom />
            <SortMenu />
          </div>
          <div className={styles.weekDayStyle}>{weekDay}</div>
        </div>
        <div className={styles.mwdControlbarClockParentContainer}>
          <div className={styles.mwdControlbarClockContainer}>
            <Clock />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Controlbar;
